import axios from 'axios';

export let headers = {
  'Tenant-Access-Token': 'OGRlYThjYTQzYzdlMDkyOWM3NjgzMTdlNThmZGIxMGE=',
  'Tenant-Access-Key': 'LClrQIp91nKjqg',
};

export const BASE_URL = 'https://immersive-game-india.confirmu.com';

export const api = axios.create({
  baseURL: BASE_URL,
  headers: headers
});